import { render, staticRenderFns } from "./OliveOil.vue?vue&type=template&id=48b02bee&scoped=true"
import script from "./OliveOil.vue?vue&type=script&lang=js"
export * from "./OliveOil.vue?vue&type=script&lang=js"
import style0 from "./OliveOil.vue?vue&type=style&index=0&id=48b02bee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b02bee",
  null
  
)

export default component.exports